// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QxMbx","question":"styles_question__hrAG0","description":"styles_description__203g5"};